var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"likes-text"},[_c('img',{staticClass:"cloud-likes",attrs:{"src":require("../../assets/images/video/heart.gif")},on:{"click":function($event){return _vm.$emit('like')}}}),_vm._v(" "),_vm._t("count")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-96f598a4","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Social/Heart.vue
// module id = null
// module chunks = 